import styles from '../../css/v9/form.pcss.json'
import { preloadIcon } from "./SVG";
import { loadStylesheet } from "../common/helpers";

let counter = 0

declare global {
  namespace preact.createElement.JSX {
    // noinspection JSUnusedGlobalSymbols
    interface IntrinsicElements {
      ['styled-checkbox']: React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLElement> & {
        label?: string
      },
        HTMLElement
      >;
    }
  }
}

// create decorator that calls the callback when the property changes
const reactive = (): any => {
  return (target: Object & {
    createAccessors: (key: PropertyKey) => void
  }, key: PropertyKey) => {
    target.createAccessors(key)
  }
}

export class StyledCheckboxComponent extends HTMLElement {
  static observedAttributes = ['name', 'label', 'value', 'checked', 'disabled']

  uid: string
  @reactive()
  name: string = ''
  @reactive()
  value: string | number = 1
  @reactive()
  label: string = ''
  @reactive()
  checked: boolean | string = false
  @reactive()
  disabled: boolean = false

  inputElement: HTMLInputElement
  labelElement: HTMLLabelElement

  // noinspection JSUnusedGlobalSymbols
  createAccessors(name: PropertyKey) {
    // @ts-ignore
    const _name = `_${name}`
    this[_name] = undefined

    Object.defineProperty(this, name, {
      get() {
        return this[_name]
      },
      set(this: StyledCheckboxComponent, value: any) {
        const prevValue = this[_name]
        this[_name] = value
        if (typeof prevValue !== 'undefined' && prevValue !== value) {
          this.render()
        }
      },
      enumerable: true,
      configurable: true
    })
  }

  getId = () => {
    return `sg-checkbox-element-${counter++}`
  }

  constructor() {
    super()
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('v9/form')
    preloadIcon('sg/checkbox-inner')
  }

  // noinspection JSUnusedGlobalSymbols
  connectedCallback() {
    this.uid = this.getId()
    this.render()
  }

  // noinspection JSUnusedGlobalSymbols
  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue === newValue) {
      return
    }
    this[name] = newValue
  }

  proxyChange = (e: Event) => {
    this.checked = (e.target as HTMLInputElement).checked
  }

  render() {
    if (!this.inputElement) {
      this.inputElement = document.createElement('input')
      this.inputElement.type = 'checkbox'
      this.inputElement.classList.add(styles['checkbox__input'])
      this.appendChild(this.inputElement)
      this.inputElement.addEventListener('change', this.proxyChange)
    }
    this.inputElement.id = this.uid
    this.inputElement.value = this.value.toString()
    this.inputElement.checked = ![false, null, undefined, 0, '0', 'false'].includes(this.checked)
    this.inputElement.disabled = ![false, null, undefined, 0, '0', 'false'].includes(this.disabled)
    if (this.name) {
      this.inputElement.name = this.name
    }

    if (!this.labelElement) {
      this.labelElement = document.createElement('label')
      this.labelElement.classList.add(styles['checkbox__container'])
      this.appendChild(this.labelElement)
    }
    this.labelElement.htmlFor = this.uid
    this.labelElement.innerHTML = ''
    const fakeCheckbox = document.createElement('div')
    fakeCheckbox.classList.add(styles['checkbox__checkbox'])
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
    use.href.baseVal = '#sg/checkbox-inner'
    svg.appendChild(use)
    fakeCheckbox.appendChild(svg)
    this.labelElement.appendChild(fakeCheckbox)

    if (this.label && this.label.trim() !== '') {
      const textLabel = document.createElement('span')
      textLabel.classList.add(styles['checkbox__text'])
      textLabel.innerText = this.label
      this.labelElement.appendChild(textLabel)
    }
  }
}

export default () => {
  customElements.define('styled-checkbox', StyledCheckboxComponent)
}
